
export const NAME_REDUCER = 'multiplePayment';

export const PREFIX_ACTIONS = 'multiplePayment_feature_';

export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
